import { useMutation } from "@apollo/client";
import { Button, Form, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import {
  CLEAR_MEMBER_ACCOUNT,
  UPDATE_MEMBER_ACCOUNT,
} from "../../../../graphql/mutations/management";
import { GET_MEMBER_LIST } from "../../../../graphql/queries/management";
import {
  clearFormAccount,
  clearFormMember,
  onChangeAccount,
} from "../../../management/redux/managementSlice";
import { TrashIcon } from "../../../../constants/icon_path";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";
import BankForm from "./BankForm";
import CryptoForm from "./CryptoForm";
import { ACCOUNT_TYPE } from "../../../../constants/app_constants";

const UpdateAccountForm = ({ handleClose }) => {
  const dispatch = useDispatch();
  const management = useSelector((state) => state.management);
  const { updateAccountForm } = management;

  const [updateAccount, { loading: loadingCreate }] = useMutation(
    UPDATE_MEMBER_ACCOUNT,
    {
      variables: {
        input: {
          memberId: updateAccountForm.memberId,
          accountNo: updateAccountForm.accountNo,
          accountName: updateAccountForm.accountName,
          bankName: updateAccountForm.bankName,
          cryptoAddress: updateAccountForm.cryptoAddress ?? "",
          cryptoNetwork: updateAccountForm.cryptoNetwork ?? "",
          accountType: updateAccountForm.accountType,
        },
      },
      refetchQueries: [{ query: GET_MEMBER_LIST }],
      onCompleted: (data) => {
        if (data) {
          handleClose();
          showSuccessToast();
          dispatch(clearFormMember());
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    }
  );

  const [clearAccount, { loading: loadingClear }] = useMutation(
    CLEAR_MEMBER_ACCOUNT,
    {
      variables: { memberId: updateAccountForm.memberId },
      refetchQueries: [{ query: GET_MEMBER_LIST }],
      onCompleted: (data) => {
        if (data.clearMemberAccount) {
          showSuccessToast();
          dispatch(clearFormAccount());
          handleClose();
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    updateAccount();
  };

  const handleChange = (e) => {
    dispatch(
      onChangeAccount({
        ...updateAccountForm,
        [e.target.name]: e.target.value,
      })
    );
  };

  const handleClear = () => clearAccount();

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <div className="text-center ">
        {updateAccountForm.updatedAccount ? (
          <Button
            variant="danger"
            disabled={loadingClear}
            onClick={handleClear}
          >
            {loadingClear ? (
              <Spinner variant="light" size="sm" animation="border" />
            ) : (
              <>
                <TrashIcon size={20} /> ລ້າງບັນຊີ
              </>
            )}
          </Button>
        ) : null}
      </div>
      {updateAccountForm.accountType == ACCOUNT_TYPE.BANK ? (
        <BankForm
          handleChange={handleChange}
          updateAccountForm={updateAccountForm}
        />
      ) : (
        <CryptoForm
          handleChange={handleChange}
          updateAccountForm={updateAccountForm}
        />
      )}

      <div className="text-center">
        <SubmitButton loading={loadingCreate} />
      </div>
    </Form>
  );
};

export default UpdateAccountForm;
